import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  isEmptyObject,
  getLocalStorageObject,
  setLocalStorageObject,
  getCustomStrikeData,
  setCustomStrikeData,
  generateUniqueId,
  calculatePrice,
  calculateSLTP,
} from "../../../util/helper";
import { getFullStrikeStocks } from "../option-chain-table/stock";
import CheckboxDropdown from "../positionPage/position-comp/dropdownWithCheckbox";
import {
  getInstruments,
  getExpiries,
  getPrice,
  getOptionChainInstrumentsData,
  getTicksData,
  getworldtimeapi,
  getHolidays,
} from "../../../redux/actions/optionChain";

import {
  placeOrdersAction,

  basketAction,
  getMarginAction,
} from "../../../redux/actions/brokerAction";
import Scroll from "../../../components/scroll/Scroll";
import AddCircleIcon from "../../../assets/icons/add.svg";
import {
  TableRow,
  Table,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
} from "@material-ui/core";
// material-ui
import { Card, Button } from "react-bootstrap";
import { Button as AntButton} from "antd";
import Centrifuge from "centrifuge";
import TableDef from "../straddle/Table";
import moment from "moment";
import Item from "antd/es/list/Item";
import { Radio, Checkbox, Tooltip, InputNumber, Switch, Select } from "antd";
// style constant
import { makeStyles } from "@material-ui/styles";
import SearchDropDown from "../../../ui-components/SearchDropDown";
import DataTableRow from "../straddle/DataTableRow";
import PlusMinStrike from "../../../components/utilities/PlusMinStrike";
import PlusMinQty from "../../../components/utilities/PlusMinQty";
import { object } from "is_js";
import { Plus, Minus, X, Percent } from "lucide-react";
import AppContext from "../../../context/Context";
import { useToast } from "components/common/custom-toast/Toast";

const exchange = "NSE";

const config = {};

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto"
  },
  textClass: {
    margin: "1px 4px",
    padding: "1px 4px",
    fontSize: "11px",
    color: ({ isDark }) => (isDark ? "#d9d9d9" : "#5e6e82"),
    fontWeight: "400",
  },
  colh: {
    padding: "1px 2px !important",
    fontSize: "0.7rem",
    // color: "#fff",
    // background: "#1c99ed",
    border: "#1px solid #ffffff",
    //  fontWeight: "bold",
    // fontFamily: "poppins",
    borderBottom: "none",
  },
  textHeading: {
    fontSize: "13px",
    margin: "0px 2px",
    color: ({ isDark }) => (isDark ? "#9da9bb" : "#5e6e82"),
    fontWeight: "bold",
    height: "25px",
    textAlign: "center",
    background: ({ isDark }) => (isDark ? "#0a0f16" : "#f0f0f0"),
  },
  strikePaper: {
    height: "450px",
    background: ({ isDark }) => (isDark ? "#121e2d" : "#ffffff"),
  },
  strikeTablePaper: {
    background: ({ isDark }) => (isDark ? "#121e2d" : "#ffffff"),
    marginBottom: "4px",
  },
  stikeContainer: {
    border: ({ isDark }) =>
      isDark ? "1px solid #323232" : "1px solid #f0f0f0",
    background: ({ isDark }) => (isDark ? "#0a0f16" : "#ffffff"),
  },
}));

const CustomOption = ({
  width,
  height,
  info,
  optionChainInstrumentsData,
  price: propPrice,
  buySellClick,
  setisQT,
  isQT,
  chartClick,
  rowHover,
  setColumns,
  DropDonwcolumns,
  isSellFirst,
  setisSellFirst,
  source,
  inputValues
}) => {
  const {
    config: { isDark },
  } = useContext(AppContext);
  const classes = useStyles({ isDark: isDark });
  const dispatch = useDispatch();
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  const basket = useSelector((state) => state.basket.data);
  const spotPrice = useSelector((state) => state?.optionChaininstruments?.spotPrice);
  const futPrice = useSelector((state) => state?.optionChaininstruments?.futPrice);
  const synFutPrice = useSelector((state) => state?.optionChaininstruments?.synFut);

  const initialData = getCustomStrikeData();

  const [tblData, setTblData] = useState(initialData?.tblData || []);
  const [symbolsToStrike, setSymbolsToStrike] = useState({});
  const [prevData, setPrevData] = useState({});
  const [tableData, setTableData] = useState({});
  const [strikeArray, setStrikeArray] = useState([]);
  const [middleStrike, setMiddleStrike] = useState();

  // Settings & Reference
  const [priceBasis, setPriceBasis] = useState(initialData?.priceBasis || "Spot"); 
  const [referencePrice, setReferencePrice] = useState(0);
  const [isSyncStrikes, setIsSyncStrikes] = useState(initialData?.isSyncStrikes ?? true);
  const [optionType, setOptionType] = useState(initialData?.optionType || "Both");

  // Consolidated Criteria State
  const [primary, setPrimary] = useState({
    criteria: initialData?.primaryCriteria || "Strike",
    ceVal: initialData?.primaryCeVal || "",
    peVal: initialData?.primaryPeVal || "",
    ceSign: initialData?.primaryCeSign || "+",
    ceType: initialData?.primaryCeType || "Multiplier",
    peSign: initialData?.primaryPeSign || "+",
    peType: initialData?.primaryPeType || "Multiplier"
  });

  const [hedge, setHedge] = useState({
    criteria: initialData?.hedgeCriteria || "Strike",
    ceVal: initialData?.hedgeCeVal || "",
    peVal: initialData?.hedgePeVal || "",
    ceSign: initialData?.hedgeCeSign || "+",
    ceType: initialData?.hedgeCeType || "Multiplier",
    peSign: initialData?.hedgePeSign || "+",
    peType: initialData?.hedgePeType || "Multiplier"
  });

  const toast = useToast();
  const stockDataRef = useRef({});

  // Helper to update specific nested state
  const updateCriteria = (key, field, val) => {
    const setter = key === 'primary' ? setPrimary : setHedge;
    setter(prev => ({ ...prev, [field]: val }));
  };

  useEffect(() => {
    setCustomStrikeData({
      tblData,
      priceBasis,
      isSyncStrikes,
      optionType,
      primaryCriteria: primary.criteria,
      primaryCeVal: primary.ceVal,
      primaryPeVal: primary.peVal,
      primaryCeSign: primary.ceSign,
      primaryCeType: primary.ceType,
      primaryPeSign: primary.peSign,
      primaryPeType: primary.peType,
      hedgeCriteria: hedge.criteria,
      hedgeCeVal: hedge.ceVal,
      hedgePeVal: hedge.peVal,
      hedgeCeSign: hedge.ceSign,
      hedgeCeType: hedge.ceType,
      hedgePeSign: hedge.peSign,
      hedgePeType: hedge.peType
    });
  }, [tblData, priceBasis, isSyncStrikes, primary, hedge]);

  const distanceOptions = [];
  for (let i = -40; i <= 40; i += 1) {
    const label = i === 0 ? "ATM" : i > 0 ? `OTM${i}` : `ITM${Math.abs(i)}`;
    distanceOptions.push({ value: i, label });
  }


  useEffect(() => {
    if (priceBasis === "Spot") setReferencePrice(spotPrice);
    else if (priceBasis === "Futures") setReferencePrice(futPrice);
    else if (priceBasis === "SynFut") setReferencePrice(synFutPrice);
  }, [priceBasis, spotPrice, futPrice, synFutPrice]);

  useEffect(() => {
    async function fetchSymbolData(
      symbolList,
      symbolsToStrikePrice,
      strikeList
    ) {
      const data = await getTicksData(symbolList);

      if (data) {
        let symbolsData = {};
        let previ = {};
        strikeList?.forEach((strike) => {
          if (
            !isEmptyObject(symbolsToStrikePrice[strike]) &&
            symbolsToStrikePrice[strike].CE &&
            symbolsToStrikePrice[strike].PE
          ) {
            const ceSymbol = symbolsToStrikePrice[strike].CE;
            const peSymbol = symbolsToStrikePrice[strike].PE;
            const prevData = {
              CE: {
                oi: data[ceSymbol]?.prev?.oi,
                lp: data[ceSymbol]?.prev?.p,
                iv: data[ceSymbol]?.prev?.iv,
              },
              PE: {
                oi: data[peSymbol]?.prev?.oi,
                lp: data[peSymbol]?.prev?.p,
                iv: data[peSymbol]?.prev?.iv,
              },
            };

            symbolsData[strike] = getFullStrikeStocks(
              data[ceSymbol],
              data[peSymbol],
              strike,
              prevData
            );
            previ = { ...previ, [strike]: prevData };
          }
        });
        setPrevData(previ);
        setTableData(symbolsData);
        stockDataRef.current = symbolsData;
      }
    }

    if (optionChainInstrumentsData && optionChainInstrumentsData.length > 0) {
      const { middleStrike: ms } = getMiddleStrike(
        optionChainInstrumentsData,
        referencePrice || propPrice || 0
      );
      console.log("ms", ms);
      setMiddleStrike(ms);

      const { symbolList, symbolsToStrikePrice, strikeList } = getSymbolList(
        optionChainInstrumentsData
      );

      setStrikeArray(strikeList.sort((a,b) => a-b)); // Ensure sorted
      fetchSymbolData(symbolList, symbolsToStrikePrice, strikeList);
    }
  }, [optionChainInstrumentsData, referencePrice, propPrice]);

  const getMiddleStrike = (optionData, price) => {
    let lastIteratePrice = 0;
    let strike = {};

    for (let i = 0; i < optionData.length; i++) {
      if (price < optionData[i]?.strikePrice) {
        const middle =
          lastIteratePrice + (optionData[i].strikePrice - lastIteratePrice) / 2;
        if (middle > price) {
          strike = { index: i - 1, middleStrike: lastIteratePrice };
        } else {
          strike = { index: i + 1, middleStrike: optionData[i].strikePrice };
        }
        break;
      }
      lastIteratePrice = optionData[i]?.strikePrice;
    }
    return strike;
  };

  const getSymbolList = (optionData) => {
    let symbolList = [];
    let strikeList = new Set();
    let symbolsToStrikePrice = {};
    for (let i = 0; i < optionData.length; i++) {
      symbolList.push(optionData[i]?.instrumentToken);

      const obj = symbolsToStrikePrice[optionData[i]?.strikePrice] || {};

      obj[optionData[i]?.instrumentType] = optionData[i]?.instrumentToken;
      obj["exchangeToken-" + optionData[i]?.instrumentType] =
        optionData[i]?.exchangeToken;
      obj["tradingSymbol-" + optionData[i]?.instrumentType] =
        optionData[i]?.tradingSymbol;
      obj["exchange-" + optionData[i]?.instrumentType] =
        optionData[i]?.exchange;
      obj["lotSize-" + optionData[i]?.instrumentType] = optionData[i]?.lotSize;
      obj["displayName-" + optionData[i]?.instrumentType] =
        optionData[i]?.displayName;

      symbolsToStrikePrice[optionData[i]?.strikePrice] = obj;
      strikeList.add(optionData[i]?.strikePrice);
    }
    setSymbolsToStrike(symbolsToStrikePrice);

    return { symbolList, symbolsToStrikePrice, strikeList: [...strikeList] };
  };

  const getStraddlePremium = (atmStrike) => {
      if(!atmStrike || !tableData[atmStrike]) return 0;
      const ceLP = tableData[atmStrike].lpCE || 0;
      const peLP = tableData[atmStrike].lpPE || 0;
      return (Number(ceLP) + Number(peLP)).toFixed(2);
  }

  const findStrikeByCriteria = (criteria, value, type, sign, criteriaType) => {
    if (!tableData || Object.keys(tableData).length === 0) return null;
    const strikes = Object.keys(tableData).map(Number).sort((a, b) => a - b);
    
    let atmIndex = -1;
    let minDiff = Number.MAX_VALUE;
    strikes.forEach((s, idx) => {
      const diff = Math.abs(s - (referencePrice || 0));
      if(diff < minDiff) {
        minDiff = diff;
        atmIndex = idx;
      }
    });

    if (criteria === "Strike") {
      if (!value) return null;
      let closest = strikes[0];
      let minD = Math.abs(strikes[0] - value);
      for(let s of strikes) {
        const d = Math.abs(s - value);
        if(d < minD) {
            minD = d;
            closest = s;
        }
      }
      return closest;
    } 
    
    if (criteria === "Distance") {
      if (value === undefined || value === null || value === "") return null;
      const idx = atmIndex + Number(value);
      if(idx >= 0 && idx < strikes.length) return strikes[idx];
      return null;
    }

    if (criteria === "Premium") {
      if (!value) return null;
      const key = type === "CE" ? "lpCE" : "lpPE";
      let closest = strikes[0];
      let minD = Math.abs((tableData[strikes[0]][key] || 0) - value);
      for(let s of strikes) {
        const lp = tableData[s][key] || 0;
        const d = Math.abs(lp - value);
        if(d < minD) {
          minD = d;
          closest = s;
        }
      }
      return closest;
    }

    if (criteria === "Delta") {
      if (!value) return null;
      const key = type === "CE" ? "deltaCE" : "deltaPE";
      let closest = strikes[0];
      let minD = Math.abs((tableData[strikes[0]][key] || 0) - value);
      for(let s of strikes) {
        const delta = tableData[s][key] || 0;
        const d = Math.abs(delta - value);
        if(d < minD) {
          minD = d;
          closest = s;
        }
      }
      return closest;
    }

    if (criteria === "Straddle Premium") {
        if (!value || !middleStrike) return null;
        const straddlePrem = getStraddlePremium(middleStrike);
        console.log("straddlePrem", straddlePrem, middleStrike);
        let adjustment = Number(value);
        if(criteriaType === "Percentage") {
            adjustment = (adjustment / 100) * straddlePrem; 
        } else {
             adjustment = adjustment * straddlePrem; // Multiplier
        }
        
        let targetStrike = middleStrike;
        if(sign === "+") targetStrike += adjustment;
        else targetStrike -= adjustment;

        // Find closest strike
         let closest = strikes[0];
         let minD = Math.abs(strikes[0] - targetStrike);
         for(let s of strikes) {
            const d = Math.abs(s - targetStrike);
            if(d < minD) {
                minD = d;
                closest = s;
            }
         }
         return closest;
    }

    if (criteria === "Underlying Price") {
        if (!value) return null;
        let underlying = referencePrice || 0;
        let adjustment = (Number(value) / 100) * underlying; // Percentage logic: Val% of Underlying

        let targetStrike = underlying;
        if(sign === "+") targetStrike += adjustment;
        else targetStrike -= adjustment;

        // Find closest strike
         let closest = strikes[0];
         let minD = Math.abs(strikes[0] - targetStrike);
         for(let s of strikes) {
            const d = Math.abs(s - targetStrike);
            if(d < minD) {
                minD = d;
                closest = s;
            }
         }
         return closest;
    }

    return null;
  };

  const createRowData = (strikeCE, strikePE, id) => {
      if((strikeCE && !tableData[strikeCE]) || (strikePE && !tableData[strikePE])) return null;
      if(!strikeCE && !strikePE) return null;
      
      const dCE = strikeCE ? tableData[strikeCE] : {};
      const dPE = strikePE ? tableData[strikePE] : {};
      
      const defaultQty = inputValues?.orderQty || 1;

      return {
          ivChgCE: dCE?.ivChgCE, ivCE: dCE?.ivCE, lpCE: dCE?.lpCE, chgCE: dCE?.chgCE,
          pChgCE: dCE?.pChgCE, oiCE: dCE?.oiCE, oiChgCE: dCE?.oiChgCE, oiPChgPE: dCE?.oiPChgCE,
          volCE: dCE?.volCE, buildupCE: dCE?.buildupCE, trendCE: dCE?.trendCE, orderflowCE: dCE?.orderflowCE,
          deltaCE: dCE?.deltaCE, gammaCE: dCE?.gammaCE, thetaCE: dCE?.thetaCE, vegaCE: dCE?.vegaCE,
          bidCE: dCE?.bidCE, askCE: dCE?.askCE, atpCE: dCE?.atpCE,
          ltpChgOpenCE: dCE?.ltpChgOpenCE, ltpChgPOpenCE: dCE?.ltpChgPOpenCE,
          
          ivChgPE: dPE?.ivChgPE, ivPE: dPE?.ivPE, lpPE: dPE?.lpPE, chgPE: dPE?.chgPE,
          pChgPE: dPE?.pChgPE, oiPE: dPE?.oiPE, oiChgPE: dPE?.oiChgPE, oiPChgPE: dPE?.oiPChgPE,
          volPE: dPE?.volPE, buildupPE: dPE?.buildupPE, trendPE: dPE?.trendPE, orderflowPE: dPE?.orderflowPE,
          deltaPE: dPE?.deltaPE, gammaPE: dPE?.gammaPE, thetaPE: dPE?.thetaPE, vegaPE: dPE?.vegaPE,
          bidPE: dPE?.bidPE, askPE: dPE?.askPE, atpPE: dPE?.atpPE,
          ltpChgOpenPE: dPE?.ltpChgOpenPE, ltpChgPOpenPE: dPE?.ltpChgPOpenPE,
          
          strike: dPE?.strike || dCE?.strike, 
          strikeCE: strikeCE,
          strikePE: strikePE,
          
          pcrCE: dPE?.pcrCE, pcrPE: dPE?.pcrPE, 
          
          ceLP: dCE?.lpCE, peLP: dPE?.lpPE,
          id: id,
          label: id,
          qty: defaultQty,
          side: id === "Primary Strike" ? "SELL" : "BUY"
      };
  };

  const handleQtyChange = (id, newQty) => {
    setTblData(prev => prev.map(row => row.id === id ? { ...row, qty: newQty } : row));
  };

  const handleSubmit = () => {
    const newTblData = [];

    const primCE = optionType !== "PE only" ? findStrikeByCriteria(primary.criteria, primary.ceVal, "CE", primary.ceSign, primary.ceType) : null;
    const primPE = optionType !== "CE only" ? findStrikeByCriteria(primary.criteria, primary.peVal, "PE", primary.peSign, primary.peType) : null;
    
    if(primCE || primPE) {
      if ((optionType === "Both" && primCE && primPE) || (optionType === "CE only" && primCE) || (optionType === "PE only" && primPE)) {
          const row = createRowData(primCE, primPE, "Primary Strike");
          if(row) newTblData.push(row);
      }
    }

    const hedgeCE = optionType !== "PE only" ? findStrikeByCriteria(hedge.criteria, hedge.ceVal, "CE", hedge.ceSign, hedge.ceType) : null;
    const hedgePE = optionType !== "CE only" ? findStrikeByCriteria(hedge.criteria, hedge.peVal, "PE", hedge.peSign, hedge.peType) : null;
    
    if(hedgeCE || hedgePE) {
      if ((optionType === "Both" && hedgeCE && hedgePE) || (optionType === "CE only" && hedgeCE) || (optionType === "PE only" && hedgePE)) {
          const row = createRowData(hedgeCE, hedgePE, "Hedge Strike");
          if(row) newTblData.push(row);
      }
    }

    setTblData(newTblData);
    if(newTblData.length === 0) toast.error("No valid strikes found.");
  };
  const handleDeleteRow = (data) => {
    setTblData(tblData.filter(item => item.id !== data.id));
  }

  const handleExecute = async () => {
      
      if(isQT) {
          let allOrders = [];
          
          // Fetch tick data for all strikes first
          const allTokens = tblData.flatMap(row => {
              const ceInfo = symbolsToStrike[row.strikeCE];
              const peInfo = symbolsToStrike[row.strikePE];
              const tokens = [];
              if(ceInfo?.CE) tokens.push(ceInfo.CE);
              if(peInfo?.PE) tokens.push(peInfo.PE);
              return tokens;
          });
          const tickData = await getTicksData(allTokens);
          
          for (const row of tblData) {
              const transactionType = row.side;
              const ceStrikeInfo = symbolsToStrike[row.strikeCE] || {};
              const peStrikeInfo = symbolsToStrike[row.strikePE] || {};

              if((row.strikeCE && !ceStrikeInfo.CE) || (row.strikePE && !peStrikeInfo.PE)) {
                  console.warn("Missing tokens for execution", row);
                  toast.error(`Missing tokens for ${row.id}`);
                  continue;
              }
              
              const calculatePriceCE = row.strikeCE ? calculatePrice(
                  tickData[ceStrikeInfo.CE]?.lp,
                  inputValues.marketProtect,
                  transactionType,
                  inputValues.orderType,
                  inputValues.marketBuffer
              ) : null;
              
              const calculatePricePE = row.strikePE ? calculatePrice(
                  tickData[peStrikeInfo.PE]?.lp,
                  inputValues.marketProtect,
                  transactionType,
                  inputValues.orderType,
                  inputValues.marketBuffer
              ) : null;
              
              // Calculate SL/TP using inputValues
              const sltpCE = row.strikeCE ? calculateSLTP(
                  inputValues.stopLossPrice,
                  inputValues.targetPrice,
                  transactionType,
                  tickData[ceStrikeInfo.CE]?.lp,
                  inputValues.riskCoverType
              ) : null;
              
              const sltpPE = row.strikePE ? calculateSLTP(
                  inputValues.stopLossPrice,
                  inputValues.targetPrice,
                  transactionType,
                  tickData[peStrikeInfo.PE]?.lp,
                  inputValues.riskCoverType
              ) : null;
              
              if (row.strikeCE) {
                allOrders.push({
                    exchange: ceStrikeInfo["exchange-CE"],
                    variety: "REGULAR",
                    validity: inputValues.validity || "DAY",
                    product: inputValues.product || "MIS",
                    orderType: inputValues.orderType || "MARKET",
                    transactionType: transactionType,
                    quantity: row.qty * ceStrikeInfo["lotSize-CE"],
                    price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(calculatePriceCE?.price),
                    triggerPrice: inputValues.customTriggerPrice > 0 ? inputValues.customTriggerPrice : 0,
                    exchangeToken: ceStrikeInfo["exchangeToken-CE"],
                    disclosedQuantity: 0,
                    stopLossPrice: sltpCE?.stopLossPrice ? parseFloat(sltpCE.stopLossPrice) : null,
                    targetPrice: sltpCE?.targetPrice ? parseFloat(sltpCE.targetPrice) : null,
                    trailReferencePoints: null,
                    trailStepPoints: null,
                    instrumentToken: ceStrikeInfo.CE,
                    marketProtect: inputValues.marketProtect,
                    marketBuffer: inputValues.marketBuffer
                });
              }

              // Build PE order if strike exists
              if (row.strikePE) {
                allOrders.push({
                    exchange: peStrikeInfo["exchange-PE"],
                    variety: "REGULAR",
                    validity: inputValues.validity || "DAY",
                    product: inputValues.product || "MIS",
                    orderType: inputValues.orderType || "MARKET",
                    transactionType: transactionType,
                    quantity: row.qty * peStrikeInfo["lotSize-PE"],
                    price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(calculatePricePE?.price),
                    triggerPrice: inputValues.customTriggerPrice > 0 ? inputValues.customTriggerPrice : 0,
                    exchangeToken: peStrikeInfo["exchangeToken-PE"],
                    disclosedQuantity: 0,
                    stopLossPrice: sltpPE?.stopLossPrice ? parseFloat(sltpPE.stopLossPrice) : null,
                    targetPrice: sltpPE?.targetPrice ? parseFloat(sltpPE.targetPrice) : null,
                    trailReferencePoints: null,
                    trailStepPoints: null,
                    instrumentToken: peStrikeInfo.PE,
                    marketProtect: inputValues.marketProtect,
                    marketBuffer: inputValues.marketBuffer
                });
              }
          }
          
          const sortedAllOrders = [...allOrders].sort((a, b) => (a.transactionType === "BUY" ? -1 : 1));

          const orderParams = sortedAllOrders.map((item) => {
              let finalOrderType = item.orderType;
              let finalPrice = item.price;

              if (item.orderType === "Mkt protect" && (item.marketProtect === 0 || (item.marketProtect === undefined && parseFloat(inputValues.marketProtect) === 0))) {
                  finalOrderType = "MARKET";
                  finalPrice = null;
              } else if (item.orderType === "MARKET") {
                  const mProtect = item.marketProtect || 0;
                  if (parseFloat(mProtect) === 0) {
                      finalOrderType = "MARKET";
                      finalPrice = null;
                  } else {
                      finalOrderType = "LIMIT";
                      const token = item.instrumentToken;
                      const ltp = tickData[token]?.lp || 0;
                      const calculated = calculatePrice(ltp, mProtect, item.transactionType);
                      finalPrice = calculated.price;
                  }
              } else if (item.orderType === "SL-M") {
                  finalOrderType = "SL";
              } else if (item.orderType === "Mkt protect" || item.orderType === "Limit at LTP" || item.orderType === "Limit with buffer") {
                  finalOrderType = "LIMIT";
              }

              return {
                  exchange: item.exchange,
                  variety: item.variety,
                  validity: item.validity,
                  product: item.product,
                  orderType: finalOrderType,
                  transactionType: item.transactionType,
                  quantity: item.quantity,
                  price: finalPrice,
                  triggerPrice: item.triggerPrice,
                  exchangeToken: item.exchangeToken,
                  disclosedQuantity: item.disclosedQuantity
              };
          });

          const orderPayload = {
              basketName: tblData.length > 1 ? `CUSTOM-MULTI` : `CUSTOM${tblData[0].strikeCE ? '-' + tblData[0].strikeCE + 'C' : ''}${tblData[0].strikePE ? '-' + tblData[0].strikePE + 'P' : ''}`,
              basketId: '',
              orders: orderParams
          };

          await dispatch(placeOrdersAction(orderPayload, info?.broker?.id));
      } else {
          let basketOrders = [];
          
          const allTokens = tblData.flatMap(row => {
              const ceInfo = symbolsToStrike[row.strikeCE];
              const peInfo = symbolsToStrike[row.strikePE];
              const tokens = [];
              if(ceInfo?.CE) tokens.push(ceInfo.CE);
              if(peInfo?.PE) tokens.push(peInfo.PE);
              return tokens;
          });
          const tickData = await getTicksData(allTokens);
          
          for (const row of tblData) {
              const transactionType = row.side;
              const ceStrikeInfo = symbolsToStrike[row.strikeCE] || {};
              const peStrikeInfo = symbolsToStrike[row.strikePE] || {};

              if((row.strikeCE && !ceStrikeInfo.CE) || (row.strikePE && !peStrikeInfo.PE)) {
                  console.warn("Missing tokens for execution", row);
                  toast.error(`Missing tokens for ${row.id}`);
                  continue;
              }

              const calculatePriceCE = row.strikeCE ? calculatePrice(
                  tickData[ceStrikeInfo.CE]?.lp,
                  inputValues.marketProtect,
                  transactionType,
                  inputValues.orderType,
                  inputValues.marketBuffer
              ) : null;
              
              const calculatePricePE = row.strikePE ? calculatePrice(
                  tickData[peStrikeInfo.PE]?.lp,
                  inputValues.marketProtect,
                  transactionType,
                  inputValues.orderType,
                  inputValues.marketBuffer
              ) : null;
              
              // Calculate SL/TP
              const sltpCE = row.strikeCE ? calculateSLTP(
                  inputValues.stopLossPrice,
                  inputValues.targetPrice,
                  transactionType,
                  tickData[ceStrikeInfo.CE]?.lp,
                  inputValues.riskCoverType
              ) : null;
              
              const sltpPE = row.strikePE ? calculateSLTP(
                  inputValues.stopLossPrice,
                  inputValues.targetPrice,
                  transactionType,
                  tickData[peStrikeInfo.PE]?.lp,
                  inputValues.riskCoverType
              ) : null;

              // Build CE basket item
              if (row.strikeCE) {
                basketOrders.push({
                  id: generateUniqueId(),
                  exchange: ceStrikeInfo["exchange-CE"],
                  variety: "REGULAR",
                  validity: inputValues.validity || "DAY",
                  product: inputValues.product || "MIS",
                  orderType: inputValues.orderType || "MARKET",
                  transactionType: transactionType,
                  quantity: row.qty * ceStrikeInfo["lotSize-CE"],
                  oldquantity: row.qty * ceStrikeInfo["lotSize-CE"],
                  price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(calculatePriceCE?.price),
                  triggerPrice: inputValues.customTriggerPrice > 0 ? inputValues.customTriggerPrice : 0,
                  exchangeToken: ceStrikeInfo["exchangeToken-CE"],
                  disclosedQuantity: 0,
                  stopLossPrice: sltpCE?.stopLossPrice ? parseFloat(sltpCE.stopLossPrice) : null,
                  targetPrice: sltpCE?.targetPrice ? parseFloat(sltpCE.targetPrice) : null,
                  trailReferencePoints: null,
                  trailStepPoints: null,
                  cellType: "CE",
                  symbol: info.instrument,
                  expiry: info.selectExpiry,
                  strike: row.strikeCE,
                  lotSize: ceStrikeInfo["lotSize-CE"],
                  instrumentToken: ceStrikeInfo.CE,
                  basketName: `CUSTOM-${row.strikeCE}C`,
                  isHedge: row.id === "Hedge Strike"
                });
              }

              // Build PE basket item
              if (row.strikePE) {
                basketOrders.push({
                  id: generateUniqueId(),
                  exchange: peStrikeInfo["exchange-PE"],
                  variety: "REGULAR",
                  validity: inputValues.validity || "DAY",
                  product: inputValues.product || "MIS",
                  orderType: inputValues.orderType || "MARKET",
                  transactionType: transactionType,
                  quantity: row.qty * peStrikeInfo["lotSize-PE"],
                  oldquantity: row.qty * peStrikeInfo["lotSize-PE"],
                  price: inputValues.customPrice > 0 ? inputValues.customPrice : parseFloat(calculatePricePE?.price),
                  triggerPrice: inputValues.customTriggerPrice > 0 ? inputValues.customTriggerPrice : 0,
                  exchangeToken: peStrikeInfo["exchangeToken-PE"],
                  disclosedQuantity: 0,
                  stopLossPrice: sltpPE?.stopLossPrice ? parseFloat(sltpPE.stopLossPrice) : null,
                  targetPrice: sltpPE?.targetPrice ? parseFloat(sltpPE.targetPrice) : null,
                  trailReferencePoints: null,
                  trailStepPoints: null,
                  cellType: "PE",
                  symbol: info.instrument,
                  expiry: info.selectExpiry,
                  strike: row.strikePE,
                  lotSize: peStrikeInfo["lotSize-PE"],
                  instrumentToken: peStrikeInfo.PE,
                  basketName: `CUSTOM-${row.strikePE}P`,
                  isHedge: row.id === "Hedge Strike"
                });
              }
          }

          // Sort basketOrders to ensure BUY orders come before SELL orders
          const sortedBasketOrders = [...basketOrders].sort((a, b) => (a.transactionType === "BUY" ? -1 : 1));

          await dispatch(basketAction(sortedBasketOrders));
          toast.success(`Added ${basketOrders.length} orders to basket`);
      }
  }


  useEffect(() => {
     setTblData([]);
  }, [info?.instrument]);

  return (
    <div className="opt-chn-tbl" style={{ maxHeight: '64vh', overflow:"auto" }}>
      <Card.Body className="p-1">
        <div className="d-flex align-items-center mb-2 flex-wrap" style={{ gap: '15px' }}>
            <div className="d-flex align-items-center">
                 <Select popupClassName="custom-select-dropdown" value={priceBasis} onChange={setPriceBasis} style={{  width: '90px' }} size="small" >
                    <Select.Option value="Spot">Spot</Select.Option>
                    <Select.Option value="Futures">Futures</Select.Option>
                    <Select.Option value="SynFut">SynFut</Select.Option>
                 </Select>
            </div>

            <div className="group-sq d-flex align-items-center">
                <Typography style={{ fontSize: "11px", marginRight: "6px" }}>Option Type</Typography>
                <Select 
                    popupClassName="custom-select-dropdown" 
                    value={optionType} 
                    onChange={(val) => {
                        setOptionType(val);
                        setTblData([]);
                    }} 
                    style={{  width: '90px' }} 
                    size="small" 
                >
                    <Select.Option value="Both">Both</Select.Option>
                    <Select.Option value="CE only">CE only</Select.Option>
                    <Select.Option value="PE only">PE only</Select.Option>
                </Select>
            </div>

            <div className="group-sq d-flex align-items-center">
                <Typography style={{ fontSize: "11px", marginRight: "6px" }}>QuikTrade</Typography>
                <Switch
                    size="small"
                    checked={isQT}
                    onChange={(e) => {
                        setisQT(e);
                        setLocalStorageObject("global", "isQT", e, getLocalStorageObject("global") || {});
                    }}
                />
            </div>

            {optionType === "Both" && (
              <div className="group-sq d-flex align-items-center">
                  <Typography style={{ fontSize: "11px", marginRight: "6px" }}>Sync Strikes</Typography>
                  <Switch 
                      size="small"
                      checked={isSyncStrikes} 
                      onChange={(checked) => {
                          setIsSyncStrikes(checked);
                          if(checked) {
                              setHedge(h => {
                                  let peVal = h.ceVal;
                                  if (h.criteria === "Delta" && h.ceVal !== "") {
                                      peVal = -Math.abs(Number(h.ceVal));
                                  }
                                  return { ...h, peVal };
                              });
                              setPrimary(p => {
                                  let peVal = p.ceVal;
                                  if (p.criteria === "Delta" && p.ceVal !== "") {
                                      peVal = -Math.abs(Number(p.ceVal));
                                  }
                                  return { ...p, peVal };
                              });
                          }
                      }}
                  />
              </div>
            )}
        </div>

        <Grid container spacing={1} className="mb-2" justifyContent="center">
            <Grid item xs={12}>
                <CriteriaInputBlock
                    title="Primary Strike"
                    data={primary}
                    straddlePremium={getStraddlePremium(middleStrike)}
                    onChange={(f, v) => {
                        let finalVal = v;
                        if (f === "criteria") {
                          if (v === "Underlying Price" || v === "Straddle Premium") {
                            updateCriteria("primary", "ceSign", "+");
                            updateCriteria("primary", "peSign", "-");
                          }
                        }
                        if (primary.criteria === "Delta") {
                            if (f === "ceVal" && v !== "") finalVal = Math.abs(Number(v));
                            if (f === "peVal" && v !== "") finalVal = -Math.abs(Number(v));
                        }
                        updateCriteria('primary', f, finalVal);
                        if(isSyncStrikes && f === 'ceVal') {
                           let syncVal = finalVal;
                           if (primary.criteria === 'Delta') {
                               syncVal = finalVal !== "" ? -Math.abs(Number(finalVal)) : "";
                           }
                           updateCriteria('primary', 'peVal', syncVal);
                        }
                    }}
                    isSync={isSyncStrikes}
                    middleStrike={middleStrike}
                    referencePrice={referencePrice}
                    strikeArray={strikeArray}
                    isDark={isDark}
                    optionType={optionType}
                />
            </Grid>
            <Grid item xs={12}>
                <CriteriaInputBlock
                    title="Hedge Strike"
                    data={hedge}
                    straddlePremium={getStraddlePremium(middleStrike)}
                    onChange={(f, v) => {
                        let finalVal = v;
                        if (f === "criteria") {
                          if (v === "Underlying Price" || v === "Straddle Premium") {
                            updateCriteria("hedge", "ceSign", "+");
                            updateCriteria("hedge", "peSign", "-");
                          }
                        }
                        if (hedge.criteria === "Delta") {
                            if (f === "ceVal" && v !== "") finalVal = Math.abs(Number(v));
                            if (f === "peVal" && v !== "") finalVal = -Math.abs(Number(v));
                        }
                        updateCriteria('hedge', f, finalVal);
                        if(isSyncStrikes && f === 'ceVal') {
                           let syncVal = finalVal;
                           if (hedge.criteria === 'Delta') {
                               syncVal = finalVal !== "" ? -Math.abs(Number(finalVal)) : "";
                           }
                           updateCriteria('hedge', 'peVal', syncVal);
                        }
                    }}
                    isSync={isSyncStrikes}
                    middleStrike={middleStrike}
                    referencePrice={referencePrice}
                    strikeArray={strikeArray}
                    isDark={isDark}
                    optionType={optionType}
                />
            </Grid>
            <Grid item xs={12} className="text-center mt-1">
                 <Button variant="primary" style={{ padding: '2px 20px', fontSize: '12px', width: "100%" }} size="sm" onClick={handleSubmit}>Submit</Button>
            </Grid>
        </Grid>
        <div className={classes.tableContainer}>
          <div>
             <Table stickyHeader >
               <TableHead>
                <TableRow>
                  <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>Side</TableCell>
                  {(optionType === "Both" || optionType === "CE only") && (
                    <>
                      <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>Strike</TableCell>
                      {DropDonwcolumns.filter(item => item.accessorKey === "deltaCE" && item.enableColumn).length > 0 && (
                          <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>CE Delta</TableCell>
                      )}
                      <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>CE LTP</TableCell>
                    </>
                  )}
                  {(optionType === "Both" || optionType === "PE only") && (
                    <>
                      <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>Strike</TableCell>
                      <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>PE LTP</TableCell>
                      {DropDonwcolumns.filter(item => item.accessorKey === "deltaPE" && item.enableColumn).length > 0 && (
                          <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>PE Delta</TableCell>
                      )}
                    </>
                  )}
                   {/* Qty Column */}
                   <TableCell id="fno-table-header-cell" align="center" className={`${classes.colh}`}>Qty</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tblData.map((row) => (
                   <DataTableRow
                      key={row.id}
                      pageType={"custom"}
                      middleStrike={middleStrike}
                      source={source}
                      rowData={row}
                      tokens={{
                           CE: symbolsToStrike[row.strikeCE]?.CE,
                           PE: symbolsToStrike[row.strikePE]?.PE,
                           "displayName-CE": symbolsToStrike[row.strikeCE]?.["displayName-CE"],
                           "displayName-PE": symbolsToStrike[row.strikePE]?.["displayName-PE"],
                           "exchange-CE": symbolsToStrike[row.strikeCE]?.["exchange-CE"],
                           "exchange-PE": symbolsToStrike[row.strikePE]?.["exchange-PE"],
                           "exchangeToken-CE": symbolsToStrike[row.strikeCE]?.["exchangeToken-CE"],
                           "exchangeToken-PE": symbolsToStrike[row.strikePE]?.["exchangeToken-PE"],
                           "lotSize-CE": symbolsToStrike[row.strikeCE]?.["lotSize-CE"],
                           "lotSize-PE": symbolsToStrike[row.strikePE]?.["lotSize-PE"],
                           "tradingSymbol-CE": symbolsToStrike[row.strikeCE]?.["tradingSymbol-CE"],
                           "tradingSymbol-PE": symbolsToStrike[row.strikePE]?.["tradingSymbol-PE"],
                      }}
                      prev={{
                        CE: prevData[row.strikeCE]?.CE,
                        PE: prevData[row.strikePE]?.PE,
                      }}
                      buySellClick={buySellClick}
                      handleDeleteRow={handleDeleteRow}
                      handleQtyChange={handleQtyChange} 
                      chartClick={chartClick}
                      rowHover={rowHover}
                      setColumns={setColumns}
                      DropDonwcolumns={DropDonwcolumns}
                      isSellFirst={isSellFirst}
                      optionType={optionType}
                    />
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
        
        {tblData.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", justifyContent: "center", paddingBlock: "12px" }}>
            <Button variant="danger" style={{fontSize: "12px", width: "100%"}} size="sm" onClick={() => handleExecute()}>
                {isQT ? "Execute" : "Add to Basket"}
            </Button>
            <Button variant="secondary" style={{fontSize: "12px", width: "100%"}} size="sm" onClick={() => setTblData([])}>
                Clear Table
            </Button>
          </div>
        )}
      </Card.Body>
    </div>
  );
};

const CriteriaInputBlock = React.memo(({ title, data, onChange, isSync, middleStrike, referencePrice, straddlePremium, strikeArray, isDark, optionType }) => {
  const isAdvanced = data.criteria === "Straddle Premium" || data.criteria === "Underlying Price";
  const distanceOptions = Array.from({ length: 81 }, (_, i) => {
    const v = i - 40;
    return { value: v, label: v === 0 ? "ATM" : v > 0 ? `OTM${v}` : `ITM${Math.abs(v)}` };
  });

  const renderDropdownScroll = (open, targetValue, array) => {
    if (!open || !targetValue) return;
    setTimeout(() => {
        const index = array.indexOf(targetValue);
        if (index === -1) return;
        const dropdown = document.querySelector(".custom-select-dropdown:not(.ant-select-dropdown-hidden)");
        const holder = dropdown?.querySelector(".rc-virtual-list-holder");
        if (holder) {
            const item = holder.querySelector(".ant-select-item-option");
            holder.scrollTop = Math.max(index * (item?.offsetHeight || 32) - holder.clientHeight / 2, 0);
        }
    }, 80);
  };

  return (
    <div style={{ border: isDark ? "1px solid #444" : "1px solid #ddd", padding: "8px", borderRadius: "10px", marginBottom: "8px" }}>
      <Typography variant="subtitle2" style={{ color: isDark ? "#fff" : "#000", marginBottom: "8px", fontSize: '11px', fontWeight: 'bold' }}>{title}</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <Select style={{width: 135}} popupClassName="custom-select-dropdown" size="small" value={data.criteria} onChange={(v) => {
            onChange('criteria', v);
            onChange('ceVal', "");
            onChange('peVal', "");
          }}>
            {["Strike", "Premium", "Delta", "Distance", "Straddle Premium", "Underlying Price"].map(c => <Select.Option key={c} value={c}>{c}</Select.Option>)}
          </Select>
        </Grid>
        
        <Grid item xs>
            <div style={{ display: 'flex', flexDirection: isAdvanced ? 'column' : 'row', gap: '8px', flexWrap: 'wrap' }}>
                {["CE", "PE"].filter(side => {
                    if (optionType === "CE only") return side === "CE";
                    if (optionType === "PE only") return side === "PE";
                    return true;
                }).map(side => {
                    const isPE = side === "PE";
                    const val = isPE ? data.peVal : data.ceVal;
                    const sign = isPE ? data.peSign : data.ceSign;
                    const type = isPE ? data.peType : data.ceType;
                    const valDisabled = isPE && isSync && optionType === "Both";

                    return (
                        <div key={side} style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ fontSize: '11px', fontWeight: 'bold', marginRight: '6px', color: isDark ? '#fff' : '#000', width: isAdvanced ? '25px' : 'auto' }}>{side}</span>
                            {isAdvanced && (
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '6px' }}>
                                    <span style={{ fontSize: '11px', marginRight: '4px', color: isDark ? '#ddd' : '#555' }}>
                                        {data.criteria === "Straddle Premium" ? `ATM (${middleStrike})` : `Und. Price (${referencePrice || 0})`}
                                    </span>
                                    <AntButton 
                                        type="default" danger={sign === "-"} size="small"
                                        style={{ padding: '0px 6px', height:'26px', color: sign === "+" ? "#26a69a" : undefined, borderColor: sign === "+" ? "#26a69a" : undefined }}
                                        onClick={() => onChange(isPE ? 'peSign' : 'ceSign', sign === "+" ? "-" : "+")}
                                    >
                                        {sign === "+" ? <Plus size={14} /> : <Minus size={14} />}
                                    </AntButton>
                                </div>
                            )}

                            {data.criteria === "Distance" || data.criteria === "Strike" ? (
                                <Select 
                                    showSearch size="small" style={{width: 100}} disabled={valDisabled}
                                    value={val || undefined} placeholder={side}
                                    onChange={(v) => onChange(isPE ? 'peVal' : 'ceVal', v)}
                                    popupClassName="custom-select-dropdown"
                                    onDropdownVisibleChange={(open) => renderDropdownScroll(open, data.criteria === "Distance" ? 0 : middleStrike, data.criteria === "Distance" ? distanceOptions.map(o => o.value) : strikeArray)}
                                >
                                    {(data.criteria === "Distance" ? distanceOptions : strikeArray).map(o => {
                                        const v = typeof o === 'object' ? o.value : o;
                                        const l = typeof o === 'object' ? o.label : o;
                                        const isATM = v === (data.criteria === "Distance" ? 0 : middleStrike);
                                        return (
                                            <Select.Option key={v} value={v} style={{ backgroundColor: isATM ? (isDark ? "#172554" : "#e6f4ff") : "transparent", fontWeight: isATM ? 600 : 400 }}>
                                                {l}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            ) : (
                                <PlusMinQty 
                                    qtyClick={(v) => onChange(isPE ? 'peVal' : 'ceVal', v)}
                                    filterValue={val} disabled={valDisabled}
                                    step={data.criteria === "Delta" || isAdvanced ? 0.1 : 1} 
                                    min={data.criteria === "Delta" && isPE ? undefined : 0}
                                    max={data.criteria === "Delta" && isPE ? 0 : undefined}
                                />
                            )}
                            
                            {data.criteria === "Straddle Premium" && (
                                <div style={{ marginLeft: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <AntButton type="default" size="small" style={{ padding: '0 6px', height:'26px' }} onClick={() => onChange(isPE ? 'peType' : 'ceType', type === "Multiplier" ? "Percentage" : "Multiplier")}>
                                        {type === "Multiplier" ? <X size={14} /> : <Percent size={14} />}
                                    </AntButton>
                                    <span style={{ fontSize: '11px', color: isDark ? '#ddd' : '#555' }}>
                                        Straddle Premium ({straddlePremium})
                                    </span>
                                </div>
                            )}

                            {data.criteria === "Underlying Price" && (
                                <div style={{ marginLeft: '6px' }}>
                                    <span style={{ fontSize: '11px', color: isDark ? '#ddd' : '#555' }}>
                                        % of Und. Price ({referencePrice})
                                    </span>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </Grid>
      </Grid>
    </div>
  );
});

export default CustomOption;
